import React from "react";
import styled from "styled-components";
import CheckBoxNew from "./CheckBoxNEw";




export default function ProductListItem(props) {
    const [open, setOpen] = React.useState(true);

   const filter = props.filter || {};
   const selectedFilters = props.selectedFilters || {};
    const {title= '',facetValues = []}  = filter;
    const {isMobile = false} = props;

  
const ItemContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: unset .5rem;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    width: 100%;
    min-width:205px;
    flex: 1;
    cursor: pointer;
    width: ${isMobile} ? '100%' : '251px';
    
    border-bottom: 1px solid rgba(73, 73, 73, 0.26);


    .icon{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    
    }
    
  `;
  
const ItemMain = styled.div`
display: flex;
flex-direction: row;
justify-content: space-between;
align-items: center;    
width: 100%;
margin-bottom: .5rem;

svg {
max-width: 20px;
rotate: -90deg;
}

`
const ItemTitle = styled.div`
    font-size: 13px;
    text-transform: uppercase;
    font-weight: 500;
    color: #333;

    `

    const ItemListContainer  = styled.div`
    display: ${open ? 'flex' : 'none'};
    flex-direction: column;
    width: 100%;
    justify-content: center;
    align-items: center;

    
    
    `






  const handleToggle = () => {
    setOpen(!open);
  };

  console.log(title, facetValues, "ProductListItem");

  return (

    <ItemContainer style={{ borderBottom: props.last ? 'none' : '1px solid rgba(73, 73, 73, 0.26)' }} >
        <ItemMain>
           <ItemTitle>{title}</ItemTitle>  <div className="icon" onClick={handleToggle} ><svg  width="7" height="11" viewBox="0 0 143 211" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="-1.12012" y="201.99" width="174.555" height="13.8977" rx="6.94886" transform="rotate(-37.6037 -1.12012 201.99)" fill="#555"></rect><rect x="6.27002" y="-2.67993" width="174.555" height="13.8977" rx="6.94886" transform="rotate(37.3964 6.27002 -2.67993)" fill="#555"></rect></svg></div>
        </ItemMain>
        <ItemListContainer>
           {facetValues?.length > 0 && facetValues?.map((item, index) => {

            return(

               <CheckBoxNew title={title} key={item.id} label={item.name} value={item.value} checked={selectedFilters[title]?.includes(item.name)} />

            )
           })}
       

        </ItemListContainer>

    </ItemContainer>
  );
}